// extracted by mini-css-extract-plugin
export default {"companyContainer":"aU-z","companyImage":"bU-z","container":"cU-z","heading":"dU-z","darkText":"eU-z","smallHeading":"fU-z","darkBackground":"gU-z","whiteBackground":"hU-z"};